import { LuAlertTriangle } from 'react-icons/lu'
import { useLogout } from '@cannect/hooks/useLogout'
import { Button } from '@cannect/new-components/atoms/Button'
import { recurrencyCopy } from '../copy'

// 010 (US3): o claim recusou o vínculo (pessoa diferente ou pedido de outro
// usuário). A compra única continua; a saída é entrar com a conta certa.
export const RecurrencyCartLinkBanner = ({ cartId }: { cartId: string }) => {
  const logout = useLogout()
  const copy = recurrencyCopy.cartLink

  const switchAccount = () =>
    logout({
      pathname: '/login',
      state: { from: { pathname: '/carrinho-wa', search: `?cart_id=${encodeURIComponent(cartId)}` } }
    })

  return (
    <section
      role="alert"
      className="flex flex-col gap-3 rounded-lg border border-solid border-warning-400 bg-warning-100 p-4 text-sm">
      <div className="flex gap-2">
        <LuAlertTriangle aria-hidden className="mt-0.5 shrink-0 text-gray-900" />
        <p className="m-0 text-gray-900">{copy.otherPatient}</p>
      </div>
      <Button variant="outline_light" size="md" className="self-start" onClick={switchAccount}>
        {copy.switchAccount}
      </Button>
    </section>
  )
}
